import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class TelecomLicenseFee {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/companyList")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getAllCompaniesV2(searchForm): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/v2/companyList", {
          params: searchForm,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getBusinessCpn(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/company-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getTypeOfDispatch(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/phiquyen/get-doc-types?page=0&size=10")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getLicNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-numbers")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public get_importers(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/bcdt/get-importers?page=0&size=99999")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/network-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public UploadFile(file): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/file-bcdt-parser`, file)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllserviceSearch() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/telcoService/businessSearch")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicCpnLicensee() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-cpn-licenses")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicCpnbusinessSearch() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/telcoService/businessSearch")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getFile(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiFile + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public BCDT_CV(querySearch?: any, checksms?: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/phiquyen/generate-doc?send_sms=${checksms}`, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public BCDT_CV_V2(querySearch?: any, checksms?: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/phiquyen/generate-docv2?send_sms=${checksms}`, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public downCV(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business//phiquyen/generate-doc/v3/export?genrateId=${id}`, {}, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public BCDT_CV_V3(querySearch?: any, checksms?: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/phiquyen/generate-doc/v3?send_sms=${checksms}`, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  public genrateList(page: any, size: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/genrates?type=PHI_QUYEN&page=${page}&size=${size}&sort=id:desc`, {})
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
  public SearchBCDT(querySearch: any): Promise<any> {
    let url = "/api/business/phiquyen/search";
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public SearchHisBCDT(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/search-bcdt-history", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public excelBcdt(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/phiquyen/generate-excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public getCpnFinan_period(id: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/get-company-by-finan-period?finance-id=${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
